import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../misc/windowDimensions";

export default function ParaghraphSection({ about }) {
  const { height, width } = useWindowDimensions();
  // console.log("checking about ", about);
  return (
    <>
      <div
        style={{
          backgroundColor: "#F9F9FA",
        }}
      >
        <div
          className="container"
          style={{ padding: "30px 5vw" }}
          dangerouslySetInnerHTML={{
            __html: about,
          }}
        />
      </div>
    </>
  );
}
